<template>
  <div
    class="subheader py-2 py-lg-4 subheader-solid"
    v-bind:class="subheaderClasses"
    id="kt_subheader"
  >
    <div
      class="
        d-flex
        align-items-center
        row
        pr-0
        flex-wrap flex-sm-nowrap
      "
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div v-if="showBack" class="mr-5">
        <b-button
          class="btn-sm d-flex align-items-center flex-row font-weight-bolder"
          variant="info"
          @click="onClickBack"
        >
          <i class="la la-arrow-left la-sm"></i>
          {{ $t("MENU.BACK") }}
        </b-button>
      </div>
      <div class="d-flex align-items-center flex-wrap">
        <h5 class="text-dark font-weight-bold my-2 mr-5">
          {{ title }}
        </h5>
        <ul
          v-if="breadcrumbs.length > 1"
          class="
            breadcrumb breadcrumb-transparent breadcrumb-dot
            font-weight-bold
            p-0
            my-2
          "
        >
          <li class="breadcrumb-item">
            <router-link :to="'/'" class="subheader-breadcrumbs-home">
              <i class="flaticon2-shelter text-muted icon-1x"></i>
            </router-link>
          </li>

          <li
            class="breadcrumb-item"
            v-for="(breadcrumb, i) in breadcrumbs"
            :key="`${i}-${breadcrumb.id}`"
          >
            <router-link
              v-if="breadcrumb.route"
              :key="i"
              :to="breadcrumb.route"
              class="text-muted"
            >
              {{ breadcrumb.title }}
            </router-link>
            <span class="text-muted" :key="i" v-if="!breadcrumb.route">
              {{ breadcrumb.title }}
            </span>
          </li>
        </ul>
      </div>
      <!-- <search-form></search-form> -->
      <!-- <div class="d-flex align-items-center"></div> -->
    </div>
  </div>
</template>

<style lang="scss">
.custom-v-dropdown {
  &.dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  &.dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
import { mapGetters } from "vuex";
// import SearchForm from './../../../components/forms/SearchForm.vue';

export default {
  components: {
    // SearchForm
  },
  name: "KTSubheader",
  props: {
    breadcrumbs: Array,
    title: String
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("subheader.width") === "fluid";
    },

    subheaderClasses() {
      const classes = [];
      const style = this.layoutConfig("subheader.style");
      if (style) {
        classes.push(style);

        if (style === "solid") {
          classes.push("bg-white");
        }

        if (this.layoutConfig("subheader.fixed")) {
          classes.push("border-top");
        }
      }
      return classes.join(" ");
    },
    showBack() {
      return !["dashboard", "kyc-kyb"].includes(this.$route["name"]);
    }
  },
  methods: {
    onClickBack() {
      if (
        this.$route?.name &&
        ["order-details", "merchant-order-details"].includes(this.$route.name)
      ) {
        window.close();
        return;
      }
      this.$router.go(-1);
    }
  }
};
</script>
